import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { INTEL_API, errMsg } from "./OutreachSendButton";

// Boutons d'action FOURNIS PAR LE SERVEUR (v2.1.6.4.1.5) : chaque bouton affiché correspond à une route réelle (méthode + chemin), à un état autorisé ; un bouton indisponible reste visible,
// désactivé, avec la raison lisible (ex. « aucun transport email configuré »). Aucune action n'est inventée côté interface. Les actions destructives demandent une confirmation.
export const ED = `${INTEL_API}/editorial`;
const uuid = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : `req-${Date.now()}-${Math.random().toString(16).slice(2)}`);

export const ActionButtons = ({ actions = [], onDone, onUi, size = "sm", exclude = [], only = null, idPrefix = "intel-action" }) => {
  const [busy, setBusy] = useState(null);
  const run = async (a) => {
    if (a.ui === "open_url") { window.open(a.path.startsWith("http") ? a.path : a.path, "_blank", "noopener"); return; }
    if (onUi && a.ui && !["resend"].includes(a.ui)) { onUi(a); return; }
    if (a.confirm && !window.confirm(a.confirm)) return;
    setBusy(a.id);
    try {
      const body = a.ui === "resend" ? { ...(a.body || {}), request_id: uuid() } : a.body;
      const r = await axios.request({ method: a.method, url: `${ED}${a.path}`, data: ["GET", "DELETE"].includes(a.method) ? undefined : body || {} });
      toast.success(`${a.label} : effectué`);
      onDone?.(r.data, a);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(null); }
  };
  const list = actions.filter((a) => !exclude.includes(a.id) && (!only || only.includes(a.id)));
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={`${idPrefix}s`}>
      {list.map((a) => (
        <span key={a.id} className="inline-flex flex-col">
          <Button size={size} variant={a.kind === "primary" ? "default" : a.kind === "danger" ? "outline" : "outline"} className={a.kind === "danger" ? "text-red-700 border-red-300" : ""}
            disabled={!a.enabled || busy === a.id} title={a.enabled ? a.label : a.disabled_reason} onClick={() => run(a)} data-testid={`${idPrefix}-${a.id.replace(/_/g, "-")}`}>{a.label}</Button>
          {!a.enabled && a.disabled_reason && <span className="text-[11px] text-muted-foreground max-w-[220px]" data-testid={`${idPrefix}-${a.id.replace(/_/g, "-")}-reason`}>indisponible : {a.disabled_reason}</span>}
        </span>
      ))}
    </div>
  );
};
